GameView  = require "views/base/game"
{ DraggyView } = require("views/components/draggy")
convert   = require("lib/convert")

class MissingWordView extends GameView
  template: require("./template")

  events: {
    "iostap .btn-done": "endGame"
  }

  serialize: ->
    data = super(arguments...)

    { title, words } = data

    title = convert.toText title
    words = words.map (w) -> convert.toText w

    filteredWords = _.filter(words, (item) -> item != "")

    words =
      for word, i in filteredWords
        unescapedWord = word
        escapedWord = word.replace(/\W/g, ((w) -> "\\#{w}"))
        leftGroup = "([^A-Z]|^)" # any non words or the beginning of string
        rightGroup = "([^A-Z]|$)" # any non words or the end of string
        substringRegex = new RegExp("#{leftGroup}#{escapedWord}#{rightGroup}", "i")
        if title.match(substringRegex)?
          incorrect = unescapedWord
          # replace matching words with placeholders
          # "hello my name" -> "hello my {{1}}"
          title = title.replace substringRegex, (matched, leftCharacter, rightCharacter) =>
            # surround placeholder with spaces
            # however, left/right character can also be non-ASCII characters such as Chinese characters
            # if it's non-ASCII then we need to keep it by appending it before/after whitespace
            leftSide = if leftCharacter == ' ' then leftCharacter else "#{leftCharacter} "
            rightSide = if rightCharacter == ' ' then rightCharacter else " #{rightCharacter}"
            leftSide + "{{#{i}}}" + rightSide
        { replaces: word, incorrect }

    # Split title into components: "hello my name" -> ["hello", "my", "name"]
    data.components =
      for component in title.trim().split(" ")
        index = +component.match(/\{\{(\d+)\}\}/)?[1]
        incorrect: words[index]?.incorrect
        replaces: words[index]?.replaces or component

    data.words = _.shuffle(filteredWords)
    data

  show: ->
    super(arguments...)
    if @draggies
      draggy.undelegateEvents() for draggy in @draggies

    @draggies =
      for el, i in @findAll(".draggy")
        draggy = new DraggyView {
          el: el
        }

        @listenTo draggy, "drag", @onDrag
        @listenTo draggy, "drop", @onDrop
        draggy

    @droppies = @getElements(".droppy", null)

    @el.classList.add "ready"

    @listenTo this, "resize", @onResize
    @enterGame()

  onResize: ->
    #  find all droppy that contains a draggy (draggy has been dragged to a droppy)
    for droppy in @droppies or []
      for id in droppy.contains or []
        draggy = _.find @draggies, { cid: id }
        # remove transition while recalc to avoid janky experience
        @transition draggy.el, "none"
        draggy.getOffset()

        # re-calculate x-axis and y-axis
        bounds = droppy.el.getBoundingClientRect()
        { left, top, width, height } = draggy.offset
        x = Math.round bounds.left + bounds.width / 2 - left - width / 2
        y = Math.round bounds.top + bounds.height / 2 - top - height / 2
        
        #  set draggy position and transform
        draggy.setPosition({ x, y })
        @transform draggy.el, {
          x: x
          y: y
        }
    
  getElements: (selector, original) ->
    if original
      for { el, contains } in original
        { el, contains, bounds: el.getBoundingClientRect() }
    else
      for el, i in @findAll(selector)
        {
          el: el
          bounds: el.getBoundingClientRect()
          contains: []
        }

  onDrag: (draggy, isInitialDrag) ->
    @droppies   = @getElements(".droppy", @droppies) if isInitialDrag
    activeIndex = draggy.closest(_.pluck(@droppies, "bounds"))

    for droppy, i in @droppies
      droppy.el.classList.toggle("active", i is activeIndex)
      droppy.isActive = i is activeIndex

    if isInitialDrag
      draggy.el.className = draggy.el.className.replace(/delay-\d/, "")

    @transform draggy.el, {
      x: draggy.x
      y: draggy.y
      transition: if isInitialDrag then "all 300ms" else "none"
    }

  onDrop: (draggy) ->
    { left, top, width, height } = draggy.offset

    droppy = (droppy for droppy in @droppies when droppy.isActive)[0]
    x = y = 0

    if droppy
      { bounds } = droppy
      x = Math.round bounds.left + bounds.width / 2 - left - width / 2
      y = Math.round bounds.top + bounds.height / 2 - top - height / 2
    else
      draggy.isPositioned = false

    if @options.data.reject and
       droppy?.el.dataset.name isnt draggy.el.dataset.name
      droppy?.isActive = false
      x = y = 0

    if draggy.x isnt x or draggy.y isnt y
      draggy.reset({ x, y })
    else
      @transform draggy.el, {
        x: draggy.x
        y: draggy.y
        transition: "all 300ms"
      }

      @checkAnswer(draggy)

    @setState(if @isTouched() then "touched" else "prompt")

  checkAnswer: (draggy) ->
    for droppy in @droppies
      droppy.el.classList.remove("active")
      containsActive = _.include(droppy.contains, draggy.cid)
      if droppy.isActive
        draggy.el.classList.add("is-positioned")
        draggy.isPositioned = true
        toReset = @getDraggyFromID(droppy.contains[0], draggy)

        if droppy.contains.length > 0 and toReset
          droppy.isActive = false
          @resetDraggy toReset

        droppy.contains =
          _.uniq(droppy.contains.concat(draggy.cid))

      else if containsActive
        droppy.contains = _.without(droppy.contains, draggy.cid)

  showAnswer: ->
    draggy.lock() for draggy in @draggies

  isTouched: ->
    touchedDroppies =
      (droppy for droppy in @droppies when droppy.contains.length > 0)

    touchedDroppies.length is @droppies.length

  getDraggyFromID: (cid, draggy) ->
    _.find @draggies, (d) ->
      d isnt draggy and d.cid is cid

  resetDraggy: (draggy) ->
    draggy.reset()
    draggy.el.classList.remove("is-positioned")
    draggy.isPositioned = false

  isCorrect: ->
    @droppies.reduce (isCorrect, d, i) =>
      isCorrect and
      @getDraggyFromID(d.contains[0])?.el.dataset.name?.toLowerCase() is d.el.dataset.name?.toLowerCase()
    , true

  answerDetails: ->
    questions = @options.strippedMetadata.questions or []
    return [] unless questions.length > 0

    details = @droppies.map (d, i) =>
      draggyId = d.contains[0]
      validText = d.el.dataset.name
      answerText = @getDraggyFromID(draggyId)?.el.dataset.name

      questionDetails = _.find questions, (q) -> q.question.content.toLowerCase() is validText.toLowerCase()
      answer   = _.find questionDetails.answers, (a) -> a.content.toLowerCase() is answerText.toLowerCase()
      answer.text = answerText
      # remove question that has already been answered, ensuring a question is only answered once
      questions = _.reject questions, (q) -> if q.question.questionId then q.question.questionId is questionDetails.question.questionId  else q.question.id is questionDetails.question.id
      { question: questionDetails.question, answer }

    return details

  endGame: ->
    super(arguments...)

    @submit()

module.exports = MissingWordView
